import * as React from 'react';

import {deserializeFieldNames} from 'nutshell-core/entities/deserialize-fields';
import type {FilterObject} from 'nutshell-core/types';

import {LoadingPage} from 'shells/loading-page/loading-page';

import type {CampaignType} from 'nutshell-graphql-types';
import type {
    EditionFragment as Edition,
    SmsEditionFragment as SmsEdition,
    SmsDripEditionFragment as SmsDripEdition,
} from 'nutshell-graphql-types';

import {getReportDefaultFields} from '../../../reports/report-constants';
import type {ReportURLParams} from '../../../reports/report-types';

import {EditionRecipientListContainer} from './edition-recipient-list-container';

type Props = {
    edition:
        | Edition
        | null
        | undefined
        | SmsEdition
        | null
        | undefined
        | SmsDripEdition
        | null
        | undefined;
    campaignType: CampaignType;
    activeFilters: FilterObject[];
    onParamChange: (arg1: any, arg2: boolean) => any;
    urlParams: ReportURLParams<'contacts'>;
    onRemoveAllFilters: () => void;
    graduatedFilters: React.ReactNode;
    fieldFilterFunction: (arg1: string) => boolean;
};

export function EditionRecipientList(props: Props) {
    if (!props.edition) {
        return <LoadingPage />;
    }

    const listParams = props.urlParams.list || {};
    const listSelectedFields =
        // @ts-expect-error
        listParams.fields && listParams.fields.contacts
            ? // @ts-expect-error
              deserializeFieldNames(listParams.fields.contacts)
            : deserializeFieldNames(getReportDefaultFields('editionEngagement'));

    const search = props.urlParams.q || '';

    return (
        <div className='routed-report-content' id='edition-recipient-list'>
            <EditionRecipientListContainer
                editionId={props.edition.id}
                comparisonEditionId={
                    props.edition.__typename === 'Edition' && props.edition.comparisonEdition
                        ? props.edition.comparisonEdition.id
                        : null
                }
                campaignType={props.campaignType}
                filters={props.activeFilters}
                search={search}
                selectedPage={
                    // @ts-expect-error
                    listParams.page && Number(listParams.page) ? Number(listParams.page) : 1
                }
                unfilteredCount={props.edition.engagementStats.totalSentCount}
                onRemoveAllFilters={props.onRemoveAllFilters}
                // @ts-expect-error
                selectedSortField={listParams.sort}
                selectedFields={listSelectedFields}
                onParamChange={props.onParamChange}
                urlParams={props.urlParams}
                graduatedFilters={props.graduatedFilters}
                fieldFilterFunction={props.fieldFilterFunction}
            />
        </div>
    );
}
